import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianNumber'
})
export class IndianNumberPipe implements PipeTransform {
  transform(value: number = 0): string {
    if (value === null || value === undefined) {
      return '';
    }

    const isNegative = value < 0;
    const absoluteValue = Math.abs(value);

    const formatter = new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 2
    });

    const formattedNumber = formatter.format(absoluteValue);
    return isNegative ? `-${formattedNumber}` : formattedNumber;
  }
}
